module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAVUlEQVQokWNkYGBgcFvw5z8DiYAFic1Igr7/TKTahM1GkpwL00iKMymykZEFXYAITf8ZGBgYqBI4cNNI1UhSAKHbSMhWuOHYNOKyHcVAXBpJTrtEAwC/1gsOyAewHAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/images/funnel-active.png
// module id = Yy0r
// module chunks = 64